import React, { useState, useEffect } from "react";
import EmbedTableCard from "../../components/EmbedTableCard";
import { fetcherWithStoreKey } from "../../utils/fetcher";
import useSWR from "swr";
import { useStores } from "../../context/storesContext";

function useIsMobileLandscape() {
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia("(max-height: 560px) and (orientation: landscape)");
    setIsMobileLandscape(mql.matches);
    const listener = (e: MediaQueryListEvent) => setIsMobileLandscape(e.matches);
    mql.addEventListener("change", listener);
    return () => mql.removeEventListener("change", listener);
  }, []);

  return isMobileLandscape;
}

function Network() {
  const { selectedStore } = useStores();
  const { data: tokenData, error: tokenError } = useSWR<{ token: string }>(
    () => [
      `/network/token`,
      
      selectedStore?.storeKey as string,
    ],
    ([url, storeKey]) =>
      fetcherWithStoreKey(url,  storeKey as string)
  );

  const isMobileLandscape = useIsMobileLandscape();
  const embedUrl = "https://eu-west-1a.online.tableau.com/t/tableauforcarrefour/views/Cockpitrseau/TableaudebordRgion" + (isMobileLandscape ? "?:device=desktop" : "");

  return (
    <EmbedTableCard
      url={embedUrl}
      device={isMobileLandscape ? "desktop" : undefined}
      token={tokenData?.token as string}
      isLoading={!tokenData}
      isUnavailable={!!tokenError || tokenData === null}
      openInformationModal={() => null}
    />
  );
}

export default Network;
